<template>
 <div>
    <!-- <el-page-header  content="提货" ></el-page-header> -->
     <div class="detailsTitle">
       <h4>提货操作</h4>
       <div @click="back"><i class="fa fa-reply"></i></div>
     </div>
        <el-form :inline="true" :rules="rules" :model="HTfrom" ref="HTfrom" class="demo-form-inline jiaoyan inpBox" label-width="120px" size="mini">
           <div class="addressBox">
        <h4 class="title">
          <span><i class="fa fa-envelope iconFont" aria-hidden="true"></i>收发货信息</span>
        </h4>
        <div>
            <el-form-item  class="is-required" label="发货单位:" prop="deliverCompany">
            <el-input  placeholder="请选择发货地址" class="disabled" maxlength="20" :readonly="true"  v-model="HTfrom.deliverCompany"></el-input>
          </el-form-item>
          <el-form-item    class="is-required" label="发货人:" prop="deliverPerson">
            <el-input  placeholder="请选择发货地址" class="disabled" maxlength="10" :readonly="true"  v-model="HTfrom.deliverPerson"></el-input>
          </el-form-item>
          <el-form-item label="发货人电话:" class="is-required" prop="deliverPhone">
            <el-input  placeholder="请选择发货地址" class="disabled" maxlength="11" :readonly="true"  type="tel" v-model="HTfrom.deliverPhone"></el-input>
          </el-form-item>
          <el-form-item  label="发货地址:" prop="deliverAddress" class="diqu1">
            <el-input  placeholder="请选择发货地址" class="disabled" maxlength="11" :readonly="true"  v-model="HTfrom.deliverAddress"></el-input>
          </el-form-item>
           <el-form-item >
              <el-button type="text"  @click="addxzdzFn(2)"><i class="fa fa-address-book-o iconFont" aria-hidden="true"></i>使用发货地址簿</el-button>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="收货单位:" prop="receivingCompany">
          <el-input  placeholder="请选择收货地址" class="disabled" maxlength="20" :readonly="true"  v-model="HTfrom.receivingCompany"></el-input>
        </el-form-item>
        <el-form-item  label="收货人:" prop="receivingPerson">
          <el-input  placeholder="请选择收货地址" class="disabled" maxlength="10" :readonly="true"  v-model="HTfrom.receivingPerson"></el-input>
        </el-form-item>
        <el-form-item label="收货人电话:" prop="receivingPhone">
          <el-input  placeholder="请选择收货地址" class="disabled" maxlength="11" :readonly="true"  type="tel" v-model="HTfrom.receivingPhone"></el-input>
        </el-form-item>
          <el-form-item  label="收货地址:" prop="receivingAddress" class="diqu1">
          <el-input  placeholder="请选择收货地址" class="disabled" maxlength="11" :readonly="true"  v-model="HTfrom.receivingAddress"></el-input>
        </el-form-item>
        <el-form-item >
              <el-button type="text"  @click="addxzdzFn(1)"><i class="fa fa-address-book-o iconFont" aria-hidden="true"></i>使用收货地址簿</el-button>
          </el-form-item>
        </div>
      </div>
      <hr>

          <div class="addressBox">
            <h4 class="title">
              <span><i class="fa fa-bookmark-o iconFont" aria-hidden="true"></i>承运车队</span>
            </h4>
            </div>
          <el-form-item label="自家承运:" prop="isSelfCarrief" class="ziti"  v-if="isFleet">
            <template >
              <el-radio-group v-model="HTfrom.isSelfCarrief" @change="changeRadeoHandler(HTfrom.isSelfCarrief)">
                <el-radio :label="1" >是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </template>
          </el-form-item>

          <el-form-item label="选择车队:" prop="carrierTenantId" class="chedui">
            <template style="width: 500px">
              <el-select v-model="HTfrom.carrierTenantId" :disabled="radiodisabled" :placeholder="radioFleet" >
                <el-option
                  v-for="item in optionsfleet"
                  :key="item.tenantCode"
                  :label="item.tenantName"
                  :value="item.tenantCode">
                </el-option>
              </el-select>
            </template>
          </el-form-item>

      <hr>
      <div class="addressBox">
        <h4 class="title">
          <span><i class="fa fa-bookmark-o iconFont" aria-hidden="true"></i>其他信息</span>
        </h4>
        <div>

      <el-form-item label="期望发货时间:" prop="hopeDeliverDate">
            <el-date-picker
              v-model="HTfrom.hopeDeliverDate"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
                placeholder="选择日期时间"
                 :picker-options="pickerOptions"
            ></el-date-picker>
      </el-form-item>
      <el-form-item label="期望到货时间:" prop="hopeReceivingDate">
            <el-date-picker
              v-model="HTfrom.hopeReceivingDate"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
                placeholder="选择日期时间"
                 :picker-options="pickerOptions"
            ></el-date-picker>
      </el-form-item>
      <div>
          <el-form-item label="备注:" class="remark" prop="remark" >
            <el-input  placeholder=""  maxlength="500" v-model="HTfrom.remark"></el-input>
          </el-form-item>
      </div>
      </div>
      </div>
      <hr>
        <div class="addressBox">
          <h4 class="title">
            <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>货物信息</span>
          </h4>
          <div class="searchBtnBox">
          <el-form-item>
           <p class="margin0">货物重量<span class="red">{{HTfrom.allWeight}}</span>吨</p>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="delFn">删除</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addFN">加卷</el-button>
          </el-form-item>
       </div>
        <el-table :data="goodList"  ref="table"   bordersize="mini"  @row-click="handleRowClick" class="table"  >
        <el-table-column type="selection" width="55" ></el-table-column>
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column property="cargoBarcode"  width="160" label="捆包号"></el-table-column>
            <el-table-column property="productTypeName" label="货物类型"></el-table-column>
        <el-table-column property="productName" width="100" :show-overflow-tooltip="true" label="品名"></el-table-column>
        <el-table-column property="model" width="120" :show-overflow-tooltip="true" label="材质"></el-table-column>
        <el-table-column property="specification" width="120" :show-overflow-tooltip="true" label="规格"></el-table-column>
        <el-table-column property="weight" label="重量"></el-table-column>
        <el-table-column property="contractNumber" width="120" :show-overflow-tooltip="true" label="合同号"></el-table-column>
        <el-table-column property="agreementNumber" width="120" :show-overflow-tooltip="true" label="合约号"></el-table-column>
        <el-table-column property="cargoLocation" width="150" :show-overflow-tooltip="true" label="货位"></el-table-column>
        <el-table-column property="organizationName" width="120" :show-overflow-tooltip="true" label="所在仓库"></el-table-column>
          <el-table-column property="instockDate" width="160" :show-overflow-tooltip="true" label="入库时间"></el-table-column>
        </el-table>
        </div>

      </el-form>
      <div class="footerBtn">
        <el-button type="primary" class="bigBtn" @click="HQsave('HTfrom',3)">暂存</el-button>
         <el-button type="primary" class="bigBtn" @click="submitFn()">提交</el-button>
      </div>
     <el-dialog title="加卷" :visible.sync="addGoodsDialog" @close="closeDialog" width="1200px" top="20px"  center>
       <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="80px" size="mini">
        <!-- <el-form-item label="审批人">
          <el-input  placeholder="审批人"></el-input>
        </el-form-item> -->
        <div class="searchBox inpBox">
            <div class="gjhBox">
              <el-form-item label="捆包号:" prop="cargoBarcode">
                <el-input  placeholder=""   type="textarea" v-model="searchFrom.cargoBarcode" class="gjh"></el-input>
              </el-form-item>
            </div>
            <div class="item">

              <el-form-item label="货物类型:" prop="productTypeId">
                <el-select  v-model="searchFrom.productTypeId"   placeholder="请选择">
                  <el-option v-for="item in productTypes" :label="item.name" :value="item.productId" :key="item.productId"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="品名:" prop="productName">
                <el-input  placeholder="" v-model="searchFrom.productName"></el-input>
              </el-form-item>
              <el-form-item label="材质:" prop="model">
                <el-input  placeholder="" v-model="searchFrom.model"></el-input>
              </el-form-item>
              <el-form-item label="规格:" prop="specification">
              <el-input  placeholder="" v-model="searchFrom.specification"></el-input>
              </el-form-item>
                <el-form-item label="合同号:" prop="contractNumber">
                <el-input  placeholder="" v-model="searchFrom.contractNumber"></el-input>
              </el-form-item>
              <el-form-item label="合约号:" prop="agreementNumber">
                <el-input  placeholder="" v-model="searchFrom.agreementNumber"></el-input>
              </el-form-item>
              <el-form-item label="货位:" prop="cargoLocation">
               <el-input  placeholder="" v-model="searchFrom.cargoLocation"></el-input>
              </el-form-item>

               <el-form-item label="入库时间:" prop="instockDate">
                    <el-date-picker
                      v-model="searchFrom.instockDate"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    ></el-date-picker>
                  </el-form-item>
            </div>
        </div>

       <div class="searchBtnBox">
          <el-form-item>
           <p class="margin0">总重量：<span class="red">{{weight}}</span>吨</p>
          </el-form-item>
         <el-form-item>
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
       </div>
      </el-form>
    </div>
     <el-table :data="addTable"  ref="addTable" :row-key="(row)=>{ return row.cargoId}" v-loading="loading"   bordersize="mini"  @selection-change='addSelectGoods'
       @row-click="addHandleRowClick"  class="table" height="500px" style="width: 100%" center  >
        <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
        <el-table-column fixed type="index"  width="55" label="序号"></el-table-column>
       <el-table-column property="cargoBarcode" width="150" :show-overflow-tooltip="true" label="捆包号"></el-table-column>
        <el-table-column property="status" label="货物状态" >
          <template scope="scope">
            {{[ "正常", "锁定" ][scope.row.status]}}
          </template>
        </el-table-column>
        <el-table-column property="productTypeName" label="货物类型"></el-table-column>
        <el-table-column property="productName" width="100" :show-overflow-tooltip="true" label="品名"></el-table-column>
        <el-table-column property="model" width="120" :show-overflow-tooltip="true" label="材质"></el-table-column>
        <el-table-column property="specification" width="120" :show-overflow-tooltip="true" label="规格"></el-table-column>
        <el-table-column property="weight" label="重量"></el-table-column>
        <el-table-column property="contractNumber" width="120" :show-overflow-tooltip="true" label="合同号"></el-table-column>
        <el-table-column property="agreementNumber" width="120" :show-overflow-tooltip="true" label="合约号"></el-table-column>
        <el-table-column property="cargoLocation" width="120" :show-overflow-tooltip="true" label="货位"></el-table-column>
        <el-table-column property="organizationName" width="120" :show-overflow-tooltip="true" label="所在仓库"></el-table-column>
          <el-table-column property="instockDate" width="160" :show-overflow-tooltip="true" label="入库时间"></el-table-column>

      </el-table>
       <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addGoodsDialog = false">取 消</el-button>
        <el-button type="primary" @click="AddJsave()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 确认密码 -->
     <el-dialog  title="确认密码" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan"  :visible.sync="dialogPaw" width="500px" center>
      <span>
         <el-form :inline="true" :rules="rules" :model="pwdFrom" ref="pwdFrom" class="demo-form-inline" label-width="100px" size="mini">
            <el-form-item label="密码:" prop="password">
                  <el-input  placeholder=""  type="password"  v-model="pwdFrom.password"></el-input>
                </el-form-item>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogPaw = false">取 消</el-button>
        <el-button type="primary" @click="pwaSaveFn('pwdFrom')">确 定</el-button>
      </span>
    </el-dialog>
 <!-- 选择地址 -->
       <selectAddress :type= "addressType"  v-if="dialogXzdz"  @handleCurrentChange="handleCurrentChange1" @destroy="destroy"></selectAddress>
  </div>
</template>

<script>
// import axios from 'axios'
import { stockTakeList, stockProductList, dropDownList, sBillAdd, checkPwd, getRelationCustomerFleet, getConsignorInfo } from '@/api/soc-stock'
import { encryption } from '@/utils/util'
import selectAddress from '@/components/networkFreight/selectAddress.vue'
export default {
  components: {
    selectAddress
  },
  data () {
    var id = this.$route.query.ids
    var weight = this.$route.query.weight
    var ids = []
    if (Array.isArray(id)) {
      ids = id
    } else {
      ids.push(id)
    }
    return {
      pwdFrom: {},
      dialogPaw: false,
      ids: ids,
      HTfrom: { allWeight: weight,
        allPrice: 0,
        storagePrice: '',
        price: '',
        pricingMethod: '',
        isSelfCarrief: 2,
        tenantCode: '',
        tenantName: '',
        carrierTenantId: ''
      },
      optionsfleet: [
        {
          tenantCode: '',
          tenantName: ''
        }
      ],
      isFleet: true,
      radiodisabled: false,
      radioFleet: '请选择车队',
      jjfangshi: [
        { val: '', name: '请选择' },
        { val: 1, name: '按吨' },
        { val: 2, name: '包干' }
      ],
      jsfangshi: [
        { val: '', name: '请选择' },
        { val: 1, name: '电汇' },
        { val: 2, name: '现金' },
        { val: 3, name: '其他' }
      ],
      goodList: [],
      rules: {
        type: [
          { required: true, message: '请选择地址类型', trigger: 'blur' }
        ],
        areaCode: [
          { required: true, message: '请选择省市县', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ],
        receivingCompany: [
          { required: true, message: '请选择收货地址', trigger: 'blur' }
        ],
        receivingPerson: [
          { required: true, message: '请选择收货地址', trigger: 'blur' }
        ],
        receivingPhone: [
          { required: true, message: '请选择收货地址', trigger: 'blur' }
        ],
        deliverAddress: [
          { required: true, message: '请选择发货地址', trigger: 'blur' }
        ],
        receivingAddress: [
          { required: true, message: '请选择收货地址', trigger: 'blur' }
        ],
        price: [
          this.rule.price
        ],
        storagePrice: [
          this.rule.storagePrice
        ],
        deliverCompany: [
          { required: true, message: '请选择发货地址', trigger: 'blur' }
        ],
        deliverPerson: [
          { required: true, message: '请选择发货地址', trigger: 'blur' }
        ],
        deliverPhone: [
          { required: true, message: '请选择发货地址', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]

      },
      dialogAddress: false,
      types: [
        { name: '收货地址', id: 1 },
        { name: '发货地址', id: 2 }
      ],
      addFrom: {},
      dialogXzdz: false,
      addressType: 1,
      addGoodsDialog: false,
      weight: 0,
      productTypes: [],
      addTable: [],
      loading: false,
      total: 0,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        status: 0,
        productType: ''
      }
    }
  },
  created () {
    stockTakeList({ cargoIds: this.ids.toString() }).then(res => {
      this.goodList = res
      this.changeRadeoHandler('2')
    })
    dropDownList({ classify: 0 }).then(res => {
      this.productTypes = res
      this.productTypes.unshift({ productId: '', name: '请选择' })
    })
    this.getConsignorInfo()
  },
  mounted () {

  },
  watch: {
    HTfrom: {
      handler (newName, oldName) {
        var allPrice = this.HTfrom.allWeight * this.HTfrom.price
        if (!Number.isNaN(allPrice)) {
          if (allPrice == 0) {
            if (this.HTfrom.storagePrice == '' || this.HTfrom.storagePrice == 0) {
              this.$set(this.HTfrom, 'allPrice', 0)
            } else {
              this.$set(this.HTfrom, 'allPrice', this.HTfrom.storagePrice)
            }
          } else {
            var yunfei = 0
            if (this.HTfrom.pricingMethod == 1) {
              let weight = this.HTfrom.allWeight
              let price = this.HTfrom.price
              yunfei = this.$math.format(this.$math.multiply(this.$math.bignumber(weight), this.$math.bignumber(price)))
            } else if (this.HTfrom.pricingMethod == 2) {
              yunfei = this.HTfrom.price
            }
            if (this.HTfrom.storagePrice == '' || this.HTfrom.storagePrice == 0) {
              this.$set(this.HTfrom, 'allPrice', fomatFloat(yunfei, 2))
            } else {
              let n = this.$math.format(this.$math.add(this.$math.bignumber(yunfei), this.$math.bignumber(this.HTfrom.storagePrice)))
              this.$set(this.HTfrom, 'allPrice', fomatFloat(n, 2))
            }
          }
        }
        function fomatFloat (num, n) {
          var f = parseFloat(num)
          if (isNaN(f)) {
            return false
          }
          f = Math.round(num * Math.pow(10, n)) / Math.pow(10, n) // n 幂
          var s = f.toString()
          var rs = s.indexOf('.')
          // 判定如果是整数，增加小数点再补0
          if (rs < 0) {
            rs = s.length
            s += '.'
          }
          while (s.length <= rs + n) {
            s += '0'
          }
          return s
        }
      },
      deep: true
      // immediate: true
    }
  },
  methods: {
    getConsignorInfo () {
      getConsignorInfo().then(res => {
        if (res == false) {
          this.isFleet = false
        }
        if (res == true) {
          this.isFleet = true
        }
      })
    },
    changeRadeoHandler (value) {
      if (value == '2') { // 否
        this.radioFleet = '请选择车队'
        this.radiodisabled = false
        this.optionsfleet = []
        getRelationCustomerFleet().then(res => {
          var huowei = { tenantCode: this.goodList[0].organizationId, tenantName: this.goodList[0].organizationName }
          this.optionsfleet = JSON.parse(res)
          this.optionsfleet.unshift(huowei)
          this.HTfrom.carrierTenantId = this.optionsfleet[0].tenantCode
        })
      } else if (value == '1') { // 是
        this.HTfrom.carrierTenantId = ''
        this.radioFleet = '自家车队'
        this.radiodisabled = true
      }
    },

    submitFn () {
      this.$refs.HTfrom.validate((valid) => {
        if (this.goodList.length >= 1) {
          if (valid) {
            this.dialogPaw = true
            this.pwdFrom = {}
          }
        } else {
          this.$alert('请添加至少一条货物', '系统提示')
        }
      })
    },
    pwaSaveFn (formName) {
      let data = encryption({
        data: this.pwdFrom,
        key: this.global.key,
        param: ['password']
      })
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          checkPwd(data).then(res => {
            this.HQsave('HTfrom', 4)
          // eslint-disable-next-line handle-callback-err
          }).catch(error => {
            this.$message({
              showClose: true,
              message: '验证密码失败',
              type: 'error',
              duration: 0,
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 确定
    HQsave (formName, n) {
      console.log(formName)
      if (this.goodList.length >= 1) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            this.HTfrom.productSource = 1
            let arr = []
            this.goodList.forEach(item => {
              arr.push(item.cargoId)
            })
            this.HTfrom.cargoIds = arr.toString()
            this.HTfrom.productNum = this.goodList.length
            this.HTfrom.status = n
            this.HTfrom.organizationId = this.goodList[0].organizationId
            this.HTfrom.organizationName = this.goodList[0].organizationName
            sBillAdd(this.HTfrom).then(res => {
              loading.close()
              this.$router.push({ name: 'sysTake' })
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                duration: 0,
                onClose () {
                  loading.close()
                }
              })
            })
          }
        })
      } else {
        this.$alert('请添加至少一条货物', '系统提示')
      }
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 删除
    delFn () {
      const selectData = this.$refs.table.selection

      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        if (this.goodList.length == 1) {
          this.$alert('不能删除全部数据', '系统提示')
        } else {
          if (selectData.length == this.goodList.length) {
            this.$alert('不能删除全部数据', '系统提示')
          } else {
            this.$confirm('是否执行删除操作?', '系统提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消'
            }).then(() => {
              selectData.forEach((val, index) => {
                // 遍历源数据
                this.goodList.forEach((v, i) => {
                  // 如果选中数据和源数据的某一条唯一标识符相等，删除对应的源数据
                  if (val.cargoId === v.cargoId) {
                    this.goodList.splice(i, 1)
                  }
                })
              })
              this.getAllWeight()
            }).catch(() => {

            })
          }
        }
      }
    },
    // 加卷
    addFN () {
      this.addGoodsDialog = true
      this.ids = []
      this.goodList.forEach(item => {
        this.ids.push(item.cargoId)
      })
      this.searchFrom.cargoIdsNotIn = this.ids
      this.searchFrom.organizationId = this.goodList[0].organizationId
      this.getGoodsList(this.searchFrom)
      this.weight = this.HTfrom.allWeight
    },
    AddJsave () {
      const selectData = this.$refs.addTable.selection
      console.log(selectData)
      this.goodList = this.goodList.concat(selectData)
      this.addGoodsDialog = false
      this.getAllWeight()
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcode) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcode.split(/[(\r\n)\r\n]+/) }
      if (this.searchFrom.instockDate) {
        this.searchFrom.instockDateStart = this.searchFrom.instockDate[0]
        this.searchFrom.instockDateEnd = this.searchFrom.instockDate[1]
      }
      this.getGoodsList(this.searchFrom)
    },
    // 选择数据
    addSelectGoods (selection) {
      this.weight = this.HTfrom.allWeight
      var that = this
      selection.forEach(item => {
        that.weight = (that.weight * 1000 + item.weight * 1000) / 1000
      })
    },
    // 点击选中
    addHandleRowClick (row, column, event) {
      this.$refs.addTable.toggleRowSelection(row)
    },
    // 获取货物列表
    getGoodsList (searchFrom) {
      this.loading = true
      stockProductList(searchFrom).then(res => {
        this.loading = false
        this.addTable = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getGoodsList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getGoodsList(this.searchFrom)
    },
    // 计算总重量
    getAllWeight () {
      this.HTfrom.allWeight = 0
      var that = this
      this.goodList.forEach(function (item, n) {
        that.HTfrom.allWeight = (that.HTfrom.allWeight * 1000 + item.weight * 1000) / 1000
      })
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        status: 0,
        organizationId: this.goodList[0].organizationId,
        instockDate: null
      }
    },
    destroy () {
      this.dialogXzdz = false
    },
    // 选择地址
    addxzdzFn (n) {
      this.addressType = n
      this.dialogXzdz = true
    },
    handleCurrentChange1 (val) {
      this.currentRow = val
      this.dialogXzdz = false
      if (this.addressType == 1) {
        this.$set(this.HTfrom, 'receivingCompany', this.currentRow.company)
        this.$set(this.HTfrom, 'receivingPerson', this.currentRow.person)
        this.$set(this.HTfrom, 'receivingPhone', this.currentRow.phone)
        this.$set(this.HTfrom, 'receivingAddress', this.currentRow.name)
        this.HTfrom.provinceCode = this.currentRow.provinceCode
        this.HTfrom.cityCode = this.currentRow.cityCode
        this.HTfrom.areaCode = this.currentRow.areaCode
        this.HTfrom.provinceName = this.currentRow.provinceName
        this.HTfrom.cityName = this.currentRow.cityName
        this.HTfrom.areaName = this.currentRow.areaName
      } else {
        this.$set(this.HTfrom, 'deliverCompany', this.currentRow.company)
        this.$set(this.HTfrom, 'deliverPerson', this.currentRow.person)
        this.$set(this.HTfrom, 'deliverPhone', this.currentRow.phone)
        this.$set(this.HTfrom, 'deliverAddress', this.currentRow.name)
      }
      this.$refs.HTfrom.clearValidate()
    },
    back () {
      this.$router.go(-1)// 返回上一层
    },
    closeDialog () {
      this.$refs.addTable.clearSelection()
      this.searchFrom = {
        pageNo: 1,
        status: 0,
        organizationId: this.goodList[0].organizationId,
        instockDate: null,
        pageSize: 50
      }
    }
  }
}
</script>

<style scoped lang='less'>
.searchBox{
  display: flex;
}
.searchBox .el-date-editor{
      width: 350px!important;
}
.gjhBox{
      flex-shrink: 0;
}
.gjhBox /deep/.el-textarea__inner{
  width:150px;
}
.diqu{
  display: flex;
  /deep/.el-form-item__content{
    display: flex;
    .el-input__inner{
      width: 200px!important;
    }
  }
}
/deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner{
  width:180px;
}

</style>
